import RepoListPage from './RepoListPage';

export default RepoListPage;
